module.exports = __webpack_public_path__ + "static/media/qb_connect_button.f4d25ab3.svg";